import React, { useEffect, useRef, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { ColDef } from "ag-grid-community";
import {
  Button,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Calendar from "../../../components/calendar/Calender";

const EtcUsers = () => {
  const [rowData, setRowData] = useState(null);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<any>(
    dayjs().add(-30, "days")
  );
  const [selectedEndDate, setSelectedEndDate] = useState<any>(dayjs());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [actionRequest, setActionRequest] = useState<Boolean>(false);
  const [activedata, setActiveData] = useState<any>(null);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [Open, setOpen] = useState<boolean>(false);

  const controller = new AbortController();
  const baseurl = process.env.REACT_APP_THM_API_URL;
  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, []);

  let startDateParam: any = selectedStartDate.format("YYYY-MM-DD");
  let endDateParam: any = selectedEndDate.add(1, "days").format("YYYY-MM-DD");

  useEffect(() => {
    if (selectedStartDate && selectedEndDate) {
      setRowData(null);
      fetchDataFromAPI(startDateParam || "", endDateParam || "");
    }
  }, [selectedStartDate, selectedEndDate]);

  const fetchDataFromAPI = async (startDate: string, endDate: string) => {
    setRowData(null);
    await axiosInterceptorInstance
      .get(
        `/dashboard/PortoutCustomerList?StartDate=${startDate}&EndDate=${endDate}`,
        { signal: controller.signal }
      )
      .then((response: any) => {
        const responseData = JSON.parse(response.data.body);
        setRowData(responseData.data);
      })
      .catch((error: any) => {
        console.error(error);
      });
  };
  const bundleUpdateRequest = async (Data: any) => {
    setActionRequest(true);
    await axiosInterceptorInstance
      .post(`${baseurl}v4/payment/card/getetcpaymentlink`, {
        msisdn: Data.msisdn,
        bundleId: Data.BundleId.toString(),
        email: Data.email,
      })
      .then((res: any) => {
        if (res.data.data !== null) {
          toast.success(res.data.data);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error: any) => {
        setOpen(false);
        setActionRequest(false);
      })
      .finally(() => {
        setOpen(false);
        setActionRequest(false);
        fetchDataFromAPI(startDateParam || "", endDateParam || "");
      });
  };
  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const ActionsCellRenderer: React.FC<{ data: any }> = ({ data }) => {
    return (
      <Button
        onClick={() => {
          setOpen(true);
          setActiveData(data);
        }}
        className="dButton dButton2"
        variant="contained"
        style={{ width: "125px", height: "32px" }}
      >
        Send Email
      </Button>
    );
  };
  const columnDefs: ColDef[] = [
    {
      field: "first_name",
      headerName: "FirstName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "last_name",
      headerName: "LastName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "msisdn",
      headerName: "Msisdn",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "email",
      headerName: "Email",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "PortOutDate",
      headerName: "PortOutDate",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "BundleName",
      headerName: "BundleName",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      headerName: "Actions",
      cellRenderer: ActionsCellRenderer,
    },
  ];
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleCalendar = () => {
    setCalendarOpen(!calendarOpen);
    handleMenuClose();
  };

  const handleStartDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedStartDate(date);
    }
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedEndDate(date);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div>
        <h2 className="heading">Etc Users</h2>
        {selectedEndDate &&
          selectedStartDate &&
          Math.floor(selectedEndDate.diff(selectedStartDate, "day", true)) ===
            30 && <span className="small-text">Last 30 Days</span>}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <button
            className="small-btn"
            style={{ visibility: rowData ? "visible" : "hidden" }}
            onClick={() => {
              if (rowData) {
                exportGridDataAsCSV();
              }
            }}
          >
            Export as CSV
          </button>
        </div>
        <IconButton
          onClick={(e: any) => {
            if (rowData) {
              handleMenuClick(e);
            }
          }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={toggleCalendar}></MenuItem>
          {selectedStartDate && selectedEndDate && (
            <Calendar
              selectedStartDate={selectedStartDate}
              selectedEndDate={selectedEndDate}
              onStartDateChange={handleStartDateChange}
              onEndDateChange={handleEndDateChange}
            />
          )}
        </Menu>
      </div>

      {!rowData && (
        <div className="dummy-conatiner">
          <CircularProgress size={40} />
        </div>
      )}
      {rowData && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={rowData}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
          ></AgGridReact>
        </div>
      )}
      {activedata && (
        <Dialog
          open={Open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Email Confirmation"}
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Would you really like to Send Email ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className="dButton dButton2 dbuttonSec"
              onClick={() => setOpen(false)}
            >
              No
            </Button>
            <div style={{ width: "30px" }}></div>
            {!actionRequest && (
              <Button
                variant="contained"
                className="dButton dButton2"
                onClick={() => {
                  bundleUpdateRequest(activedata);
                }}
                autoFocus
              >
                Yes
              </Button>
            )}
            {actionRequest && (
              <Button className="dButton dButton2" variant="contained">
                <CircularProgress color="inherit" size={30} />
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
    </motion.div>
  );
};

export default EtcUsers;
